module.exports = __webpack_public_path__ + "img/a.1ade6b45.png";